export const I18N_DOMAIN_DATAVIZ = 'tui-dataviz';
